export default {"src":"/_next/static/media/sun_regular.7c0ff44e.svg","height":24,"width":24};